import type { RichTextProps } from '../../../components/RichText/RichText';

import RichText from '../../../components/RichText/RichText';

import useYjsField from '../../collaboration/useYjsField';
import { useFieldContext } from '../../form';
import { useFieldErrors } from '../../useFieldErrors';

const RichtextField = ({
  onFocus,
  onBlur,
  disabled,
  ...props
}: RichTextProps) => {
  const field = useFieldContext<string>();
  const errors = useFieldErrors(field.name);
  const yjsField = useYjsField('string');

  const onChange = (value: string) => {
    field.handleChange(value);
    yjsField.update(value);
  };

  const onFieldFocus = (name?: string) => {
    onFocus?.(name);
    yjsField.onFocus();
  };

  const onFieldBlur = (name?: string) => {
    onBlur?.(name);
    field.handleBlur();
    yjsField.onBlur();
  };

  return (
    <RichText
      {...props}
      name={field.name}
      value={field.state.value}
      onChange={onChange}
      error={errors}
      onFocus={onFieldFocus}
      onBlur={onFieldBlur}
      disabled={disabled || !!yjsField.isBeingEdited}
      editors={yjsField.fieldEditors}
    />
  );
};

export default RichtextField;
